import { all, call, takeLatest, put } from 'redux-saga/effects'
import { showAlertMessage } from '../alert/actions'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'

import * as actions from './actions'
import * as services from './services'
import { fetchRooms } from '../chats/services'

export function * viewNotificationRSPA (action) {
  try {
    const { payload: { notificationId } } = action
    const response = yield call(services.viewNotification, notificationId)
    resolvePromiseAction(action, response)
  } catch (err) {
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * getNotificationsRequest ({ payload }) {
  try {
    const page = payload?.page || 1

    const response = yield call(services.getNotifications, {
      params: {
        'page[number]': 10,
        'q[s]': 'updated_at asc',
        'q[notification_type_eq]': 9,
        ...payload?.params
      },
      page
    })

    let updatedData = [...response.data]
    const roomIds = response.data.map(item => item.room_id)
    if (roomIds.length > 0) {
      const notificationRooms = yield call(fetchRooms, {
        page: 1,
        params: { 'q[room_id_in]': roomIds.join(',') }
      })
      updatedData = response.data.map(item => {
        return {
          ...item,
          room: notificationRooms.data.find(prev => +prev.id === +item.room_id)
        }
      })
    }

    yield put(
      actions.getNotificationsSuccessful({
        response: { ...response, data: updatedData },
        current_page: page
      })
    )
  } catch (err) {
    yield put(actions.getNotificationsFailure(err))
    yield put(
      showAlertMessage({
        message: 'Falha ao carregar as notificações.',
        severity: 'error'
      })
    )
    console.error(err)
  }
}

export function * watchFetchEvents () {
  yield takeLatest(actions.getNotifications, getNotificationsRequest)
  yield takeLatest(actions.viewNotification.request, viewNotificationRSPA)
}

export default function * notificationSagas () {
  yield all([watchFetchEvents()])
}
